import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueHead from 'vue-head'
import moment from 'moment'
import VueCookies from 'vue-cookies'
import Vue2Editor from "vue2-editor";
Vue.config.productionTip = false;

Vue.use(VueHead,{
  inner:"Intra",
  complement:"STAPMEDIF"
});
Vue.use(VueCookies);
Vue.use(Vue2Editor);

Vue.filter('formatDate', function(value:string) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY')
  }
})
Vue.filter('formatDateHour', function(value:string) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY HH:mm:ss')
  }
})
Vue.filter('formatHour', function(value:string) {
  if (value) {
    return moment(String(value),"HH:mm:ss").format('HH:mm:ss')
  }
})

Vue.$cookies.config('365d')

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

